import type { MarketVariants } from '@/lib/i18n'

export type Slide03Copy = {
  title: string
}

export const copy: MarketVariants<Slide03Copy> = {
  US: {
    title: 'Not anymore.',
  },
  ar: {
    title: 'لم يعد الأمر كذلك.',
  },
}
